var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper wrapper-full-page pt-4 px-4"},[_c('card',{staticClass:"card jumbotron text-center"},[_c('img',{staticClass:"mb-4",staticStyle:{"height":"120px"},attrs:{"src":"img/ethos-logo.svg"}}),_c('h1',[_vm._v(_vm._s(_vm.code))]),_c('p',[_vm._v(_vm._s(_vm.message))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }